module.exports = __webpack_public_path__ + "img/hero-bg.57a4e2ce.svg";